// extracted by mini-css-extract-plugin
export default {"endGame":"Stats_endGame__YL0Er","codeRow":"Stats_codeRow__8HwPx","buttonDiv":"Stats_buttonDiv__esTXA","hr":"Stats_hr__qJSvK","button":"Stats_button__Pe7MR"};